var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"tabs-container",attrs:{"id":"tab-menus","center-active":""}},_vm._l((_vm.sections),function(item,index){return _c('v-tab',{key:index,attrs:{"to":{ name: item.pathName }}},[_c('span',{staticClass:"font_tabs",domProps:{"textContent":_vm._s(_vm.$t(item.title))}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }